export const NAME = 'dashboards-campaigns-sidebar';

export const REPORT_NOT_FOUND_DIALOG = `${NAME}/REPORT_NOT_FOUND_DIALOG`;

export const PRINT_AVAILABLE_VIEWS = ['MANAGER', 'SELLER', 'PPZ'];

export const DASHBOARD_KEY_WINDOWS = {
	manager: 'dashboard-manager',
	seller: 'dashboard-seller',
	ppz: 'dashboard-ppz',
};
